/**
 * This matches the tailwind configuration values, but for some reason
 * I wasn't able to actually import the tailwind configuration. Instead of
 * burning time trying to get that working, I just copied it here.
 *
 * All this is to say, if you change a tailwind breakpoint, you'll probably
 * want to change this one as well.
 *
 * @type {{xl: string, md: string, sm: string, lg: string}}
 */
const breakpoints = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
};

export default breakpoints;
